// extracted by mini-css-extract-plugin
export default {"brief-live__container":"styles_brief-live__container__GigZ4","brief-live__switch-tab":"styles_brief-live__switch-tab__IAGPZ"};